import {Chrome, SiteFooter} from './components/Chrome';
import {Modals} from './components/Modals';
import {BriefScreen} from './screens/BriefScreen';
import {PreviewScreen} from './screens/PreviewScreen';
import {WorkspaceScreen} from './screens/WorkspaceScreen';
import {StudioProvider, useStudio} from './store';

function Screens() {
  const s = useStudio();

  // The workspace and preview both read a loaded project, so a screen change that
  // outlives its project falls back to the brief rather than rendering half a page.
  const screen = s.screen !== 'brief' && !s.project ? 'brief' : s.screen;

  return (
    <>
      <Chrome />
      {screen === 'brief' && <BriefScreen />}
      {screen === 'workspace' && <WorkspaceScreen />}
      {screen === 'preview' && <PreviewScreen />}
      <SiteFooter />
      <Modals />
    </>
  );
}

export function App() {
  return (
    <StudioProvider>
      <Screens />
    </StudioProvider>
  );
}
